import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Logo from '../../../assets/proofpoint-logo-black.svg';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import { greyscale } from '../../common/theme/colors';
import { withStyles } from '@material-ui/core/styles';

const styles = ( theme ) => ( {
    container: {
        borderBottom: `1px solid ${greyscale[300]}`,
        paddingBottom: 10,
        paddingTop: 10,
    },
    logo: {
        alignItems: 'flex-start',
        display: 'flex',
        height: '100%',
        justifyContent: 'flex-end',
    },
} );

const ReportHeader = ( { classes, header } ) => {
    return (
        <div className="only-print">
            <Grid container className={classes.container}>
                <Grid item xs={3}>{/* This empty container is for PDF alignment */}</Grid>
                <Grid item xs={6}>
                    <Typography variant="h5" align="center">
                        {header.title}
                    </Typography>
                    <Typography color="textSecondary" variant="subtitle1" align="center">
                        {header.startDate} to {header.endDate} by {header.interval}
                    </Typography>
                    { ( header.domainType || header.domain ) &&
                        ( <Typography color="textSecondary" variant="subtitle1" align="center">
                            {header.domainType ? header.domainType : header.domain } - Data Source: Consumer Mailboxes
                        </Typography> )
                    }
                </Grid>
                <Grid item xs={3}>
                    <div className={classes.logo}>
                        <img src={Logo} alt="Proofpoint Logo" style={{ width: '80%' }}/>
                    </div>
                </Grid>
                <Divider/>
            </Grid>
        </div>
    );
};

ReportHeader.propTypes = {
    classes: PropTypes.object.isRequired,
    header: PropTypes.shape( {
        domain: PropTypes.string,
        domainType: PropTypes.string,
        endDate: PropTypes.string.isRequired,
        interval: PropTypes.string.isRequired,
        startDate: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    } ),
};

export default withStyles( styles )( ReportHeader );
